import React, { useState } from 'react';
import './App.css';
import Cart from './Cart';
import Navtop from './Navtop';
import Navbar from './Navbar';
import MainPart from './MainPart';
import Products from './Products';
import LaptopsImage from './LaptopsImage';
import LaptopsImage2 from './LaptopsImage2';
import BlogPart from './BlogPart';
import Footer from './Footer';


function App() {
  const [cart, setCart] = useState([]);

  const addToCart = (product) => {
    const existingIndex = cart.findIndex(item => item.title === product.title);
    if (existingIndex !== -1) {
      const updatedCart = [...cart];
      updatedCart[existingIndex].quantity = (updatedCart[existingIndex].quantity || 0) + 1;
      setCart(updatedCart);
      alert('Product added to the cart');
    } else {
      setCart([...cart, { ...product, quantity: 1 }]);
      alert('Product added to the cart');
    }
  };
  

  const removeFromCart = (index) => {
    const updatedCart = cart.filter((item, i) => i !== index);
    setCart(updatedCart);
  };

  const updateQuantity = (index, newQuantity) => {
    const updatedCart = [...cart];
    if (updatedCart[index]) {
      updatedCart[index].quantity = newQuantity;
      setCart(updatedCart);
    }
  };

  const [cartVisible, setCartVisible] = useState(false);

  const toggleCartVisibility = () => {
    setCartVisible(prevState => !prevState);
  };

  const hideCart = () => {
    setCartVisible(false);
  };

  return (
    <div>
      <Cart isVisible={cartVisible} hideCart={hideCart} cart={cart} removeFromCart={removeFromCart} updateQuantity={updateQuantity} quant/>
      <Navtop />
      <Navbar onToggleCart={toggleCartVisibility}/>
      <MainPart />
      <Products addToCart={addToCart} />
      <LaptopsImage />
      <Products addToCart={addToCart} />
      <LaptopsImage2 />
      <BlogPart />
      <Footer />
    </div>
  );
}

export default App;
